import { render, staticRenderFns } from "./PositionShow.vue?vue&type=template&id=50a7af81&scoped=true&"
import script from "./PositionShow.vue?vue&type=script&lang=js&"
export * from "./PositionShow.vue?vue&type=script&lang=js&"
import style0 from "./PositionShow.vue?vue&type=style&index=0&id=50a7af81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a7af81",
  null
  
)

export default component.exports